import { memo, useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useLocale } from '../../context/LocaleProvider';
import { useAuth } from '../../context/AuthContext';
import Container from 'react-bootstrap/Container';
import { Nav, Navbar, NavDropdown, Offcanvas } from 'react-bootstrap';
import Config from '../../config/config';
import UserGroup from '../../model/usergroup';

const LogoType = { GENERAL: 1, AGENT: 2 };

function findLogoType(value) {
    return Object.keys(LogoType).find(key => {
        return LogoType[key] === value;
    });
}

function MainNavBar({ logoType }) {
    const { sessionViewData, logout } = useAuth();
    const { t } = useLocale();
    const logoName = Config.app.logoName;
    const navigate = useNavigate();
    logoType = typeof logoType === "number" && typeof findLogoType(logoType) === "string" ? LogoType[findLogoType(logoType)] : LogoType.GENERAL
    var [ showFullMenu, setShowFullMenu ] = useState();
    const { pathname } = useLocation();

    // The layout stays mounted between pages, so close the mobile menu when the route changes.
    useEffect(() => {
        setShowFullMenu(false);
    }, [ pathname ]);

    const handleToggleMenu = function() {
        setShowFullMenu(showFullMenu => !showFullMenu);
    }
    
    const handleSignOut = async() => {
        await logout();
        navigate("/");
    }

    var LoginLink;
    var LogoutLink;
    var MyAccountLink;
    var AgentAnalyticsLink;
    if (sessionViewData.loading) {
        LoginLink = null;
        LogoutLink = null;
        MyAccountLink = null;
    } else if (sessionViewData.data) {
        LoginLink = null;
        LogoutLink = (<button className="nav-link w-100 text-start" style={{"marginLeft": 12, "marginRight": 12 }} onClick={handleSignOut} title={t("menu.signout")}>{t("menu.signout")}</button>);
        if (sessionViewData.data.user.user_group_id === UserGroup.Agent) {
            AgentAnalyticsLink = (<NavDropdown.Item as={NavLink} to="/account/agent/insights">{t("menu.agent.insights")}</NavDropdown.Item>)
        }
        MyAccountLink = (<>
            <NavDropdown className="nav-link w-100" title={t("menu.my_account")}>
                <NavDropdown.Item as={NavLink} to="/account">{t("menu.my_account")}</NavDropdown.Item>
                {AgentAnalyticsLink}
            </NavDropdown>
        </>);

    } else {
        LoginLink = (<NavLink className="nav-link nav-item w-100" to="/login" title={t("menu.login")}>{t("menu.login")}</NavLink>);
        LogoutLink = null;
        MyAccountLink = null;
    }
    var MenuBlock = (
        <Nav>
            {LoginLink}
            {MyAccountLink}
            {LogoutLink}
        </Nav>
    )


    var NavBandContentBlock;
    var NavBandOffCanvas;
    var navBandLink;

    if (logoType === LogoType.AGENT) {
        navBandLink = "/agent";
        NavBandContentBlock = (<>{logoName}<br/>{t("general.logo.agent")}</>);
        NavBandOffCanvas = (<>{logoName}<br/>{t("general.logo.agent")}</>);
    } else {
        navBandLink = "/";
        NavBandContentBlock = (<>{logoName}</>);
        NavBandOffCanvas = (<>{logoName}</>);
    }

    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navbar-expand-lg bg-body-tertiary d-flex justify-content-between">
                <Container>
                    <Navbar.Brand>
                        <NavLink className="navbar-brand" to={navBandLink}>{NavBandContentBlock}</NavLink>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" className="me-2 " onClick={handleToggleMenu}/>
                    <div className='d-none d-lg-block'>
                        {MenuBlock}
                    </div>
                </Container>
            </Navbar>
            <Offcanvas show={showFullMenu} onHide={handleToggleMenu} backdrop={true} placement="start">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{NavBandOffCanvas}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {MenuBlock}
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}   

export const MainNavBarLogoType = LogoType;

export default memo(MainNavBar);